module.exports = __webpack_public_path__ + "img/list-active.2bf6c94f.svg";